import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getProject } from 'project/ducks/project';
import { getSlides } from 'project/components/tour_slides';
import { getCategory } from 'common/ducks/categories';
import { isProjectTagline } from 'project/utils';
import Tour from 'project/components/tour';

const mapStateToProps = (state, { params }) => {
  const project = getProject(state);
  const category = getCategory(state.categories.data, project.category);
  const entryName = (
    project.entry_type === "image"? "design" : (isProjectTagline(project)? "tagline" : "name")
  );
  const creativeName = project.entry_type === "image"? "designer" : "creative";
  const allSlides = getSlides({ project, entryName, creativeName }).filter(s => s.show);

  return {
    intro: allSlides[0],
    slides: allSlides.slice(1),
    categorySlug: category? category.slug : "",
    subCategorySlug: params.subcategory || "",
    project
  };
};

export default withRouter(connect(mapStateToProps)(Tour));



// WEBPACK FOOTER //
// ./project/containers/tour.js